import {
	INSPIRATION_MONTHLY_SLIDER_MAX_CEILING,
	INSPIRATION_MONTHLY_SLIDER_MAX_FLOOR,
	INSPIRATION_MONTHLY_SLIDER_MAX_ROUNDING,
} from "web_myplann/Inspiration/constants";

export const getMonthlyAmountSliderMax = (reference?: number): number => {
	if (reference === undefined || reference <= 0)
		return INSPIRATION_MONTHLY_SLIDER_MAX_FLOOR;
	const doubled =
		Math.ceil((reference * 2) / INSPIRATION_MONTHLY_SLIDER_MAX_ROUNDING) *
		INSPIRATION_MONTHLY_SLIDER_MAX_ROUNDING;
	return Math.min(
		INSPIRATION_MONTHLY_SLIDER_MAX_CEILING,
		Math.max(INSPIRATION_MONTHLY_SLIDER_MAX_FLOOR, doubled),
	);
};
